module.exports = __webpack_public_path__ + "img/index室外机.5597cb5f.jpg";